<header>
  <div class="container-fluid">
      <div class="row">
          <div class="col-lg-12">
            <div class="navtop">
              <div class="logo">
                <a><img src="./assets/images/logo_1.png" class="img-fluid" alt="logo" height="60" /></a>                      
                  <a ><img src="./assets/images/logo_2.png" class="img-fluid" alt="logo"  height="60" /></a>
                  <a ><img src="./assets/images/logo_4.png" class="img-fluid" alt="logo"  height="60" /></a>
                  <a ><img src="./assets/images/logo_3.png" class="img-fluid" alt="logo"  height="60" /></a>  
                  <!-- <a><img src="./assets/images/USAID logo.png" class="img-fluid" alt="logo" width="226" height="67" /></a>                      
                  <a ><img src="./assets/images/MISAAL Logo.jpg" class="img-fluid" alt="logo" width="328" height="65" /></a>
                  <a ><img src="./assets/images/umclogo_new.png" class="img-fluid" alt="logo" width="178" height="60" /></a> -->
              </div>
            </div>
          </div>
      </div>
  </div>
</header>
<section class="content">
  <div class="welcome">
    <div class="container">
      <div class="row justify-content-end">
        <div class="col-lg-10 col-xs-12 p-0">
          <div class="welcome_info">
            <h1>{{'PAGES.PRIVACYPOLICY.WELCOMETOSANITATION' | translate}}</h1>
            <p>{{'PAGES.TERMSOFUSE.WELCOMETEXT1' | translate}}</p>
            <p>{{'PAGES.TERMSOFUSE.WELCOMETEXT2' | translate}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content_details">
    <div class="container">
      <div class="row justify-content-start">
        <div class="col-lg-10 p-0">
          <div class="content_info">
            <div class="form">
              <div class="other_details">
                <h4 style="color: blue"><u>{{'PAGES.PRIVACYPOLICY.PRIVACYPOLICY' | translate}}</u></h4>
                  <p>{{'PAGES.PRIVACYPOLICY.TEXT2' | translate}}</p>

                  <p>{{'PAGES.PRIVACYPOLICY.TEXT3' | translate}}</p>
                  
                  <p>{{'PAGES.PRIVACYPOLICY.TEXT4' | translate}} </p>
                  <!-- <p>When you select “Agree & Continue” you are agreeing to the “Terms of Use” of the application.</p> -->
                  <div class="text-right">
                    <button routerLink="/" class="btn btn-primary">{{'PAGES.COMMON.BACKBTN' | translate}}</button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<footer>
  <div class="container-fluid">
    <div class="row copyright">

    <div class="col-sm-12 col-md-12 col-lg-2">
      <button class="btn bg-transparent" style="color:white;font-size: 10px;" [routerLink]="['/terms-of-use']">{{'PAGES.COMMON.TERMSOFUSE' | translate}}</button>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-8">
      <p class="btn bg-transparent" style="font-size: 10px;">Powered by Urban Management Centre, 2020.</p>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-2">
      <button class="btn bg-transparent" style="color:white;font-size: 10px;" [routerLink]="['/privacy-policy']">{{'PAGES.COMMON.PRIVACYPOLICY' | translate}}</button>
    </div>
    </div>
  </div>
</footer>